import api from "!../../../../../../../web/auh-v2/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../../web/auh-v2/node_modules/css-loader/dist/cjs.js??clonedRuleSet-23.use[1]!../../../../../../../web/auh-v2/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../../web/auh-v2/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-23.use[2]!../../../../../../../web/auh-v2/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-23.use[3]!../../../../../../../web/auh-v2/node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=style&index=0&id=60d20b5d&prod&lang=scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};